import { render, staticRenderFns } from "./save-calculation.vue?vue&type=template&id=5edbadeb&"
import script from "./save-calculation.vue?vue&type=script&lang=js&"
export * from "./save-calculation.vue?vue&type=script&lang=js&"
import style0 from "./save-calculation.vue?vue&type=style&index=0&id=5edbadeb&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5edbadeb')) {
      api.createRecord('5edbadeb', component.options)
    } else {
      api.reload('5edbadeb', component.options)
    }
    module.hot.accept("./save-calculation.vue?vue&type=template&id=5edbadeb&", function () {
      api.rerender('5edbadeb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations/create/save-calculation.vue"
export default component.exports